import { EnvironmentProviders, Provider } from '@angular/core';
import { provideSoftAppsRoutes } from '@softapps/core';
import { deliveryNoteProcessingRoutes } from './delivery-note-processing.routes';

export const provideDeliveryNoteProcessingModule: () => Array<Provider | EnvironmentProviders> = () => [
  provideSoftAppsRoutes({ app: deliveryNoteProcessingRoutes })
];
